import actionTypes from '../actionTypes';

const switchTheme = () => ({
  type: actionTypes.SWITCH_THEME,
});

export default { switchTheme };
